import { all, put, takeLatest } from "redux-saga/effects";
// import { FETCH_OSPEDALI, fetchOspedaliSuccess, preparaListaOspedali, mockOspedali } from "./index";
import { FETCH_OSPEDALI, fetchOspedaliSuccess, preparaListaOspedali } from "./index";
import { createRequest } from "../../tools";

function* fetchOspedaliWorker() {
  try {
    const response = yield createRequest("GET", "/surgerytracker/hospitalcodes/hospitals");
    if (response.status === 200) {
      const infoFromResponse = preparaListaOspedali(response.data);
      if (infoFromResponse) yield put(fetchOspedaliSuccess(infoFromResponse));
      else throw new Error("Nessun ospedale presente");
    } else throw response.message;
  } catch (e) {
    console.error("Errore durante il caricamento degli ospedali:", e);
    yield put(fetchOspedaliSuccess(null));
    //TODO Togliere quando servizi funzionano
    // const infoFromResponse = preparaListaOspedali(mockOspedali);
    // yield put(fetchOspedaliSuccess(infoFromResponse));
  }
}

function* fetchOspedaliWatcher() {
  yield takeLatest(FETCH_OSPEDALI, fetchOspedaliWorker);
}

export function* commonWatchers() {
  yield all([fetchOspedaliWatcher()]);
}
